import React, { type PropsWithChildren } from 'react';

import NavigationConfirmationEnvironmentContext from './context';
import useNavigationConfirmationEnvironment from './useNavigationConfirmationEnvironment';

const ContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const value = useNavigationConfirmationEnvironment();

  return (
    <NavigationConfirmationEnvironmentContext.Provider value={value}>
      {children}
    </NavigationConfirmationEnvironmentContext.Provider>
  );
};

export default ContextProvider;
